const mainNavigation = document.querySelector('#main-navigation');
const body = document.querySelector('body');
const navButton = document.querySelector('#nav-button');
if (mainNavigation) {
  navButton.addEventListener('click', function () {
    body.classList.toggle('nav-open');
    navButton.classList.toggle('open-menu');
    mainNavigation.toggleAttribute('open');
  });
}

// Predictive search
const searchTrigger = document.querySelector('.search-trigger');
const searchOverlay = document.querySelector('.search-overlay');
const searchInput = document.getElementById('search-input');
const searchResults = document.getElementById('search-results');

if (searchTrigger && searchOverlay) {
  function openSearch() {
    document.body.classList.add('search-open');
    searchInput.focus();
  }

  function closeSearch() {
    document.body.classList.remove('search-open');
    searchInput.value = '';
    searchResults.innerHTML = '';
  }

  searchTrigger.addEventListener('click', openSearch);

  searchOverlay.querySelectorAll('[data-closesearch]').forEach((btn) => {
    btn.addEventListener('click', closeSearch);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });

  let searchTimeout;
  searchInput.addEventListener('input', () => {
    clearTimeout(searchTimeout);
    const query = searchInput.value.trim();
    if (query.length < 2) {
      searchResults.innerHTML = '';
      return;
    }
    searchTimeout = setTimeout(() => {
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`)
        .then((res) => res.json())
        .then((data) => {
          const products = data.resources.results.products;
          if (!products.length) {
            searchResults.innerHTML = '<li>No results found.</li>';
            return;
          }
          searchResults.innerHTML = products.map((product) => {
            const image = product.featured_image
              ? `<img src="${product.featured_image.url}" alt="${product.featured_image.alt || product.title}">`
              : '';
            return `
              <li>
                <a href="${product.url}">
                <div class="images">
                  ${image}
                </div>
                <p class="product-title">${product.title}</p>
                </a>
              </li>`;
          }).join('');
        });
    }, 250);
  });
}

// Archive overlay on submenu hover
const overlayArchive = document.querySelector('.overlay-archive');
if (overlayArchive) {
  document.querySelectorAll('.store-menu .menu-item-has-children').forEach((item) => {
    item.addEventListener('mouseenter', () => {
      if (window.innerWidth > 1199) overlayArchive.classList.add('visible');
    });
    item.addEventListener('mouseleave', () => {
      overlayArchive.classList.remove('visible');
    });
  });
}

// Product image gallery
const galleryMainImages = document.querySelectorAll('.gallery-main-image');
if (galleryMainImages.length) {
  document.querySelectorAll('.gallery-thumbnail').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const index = parseInt(thumb.dataset.index);
      galleryMainImages.forEach((img) => img.classList.remove('active'));
      galleryMainImages[index].classList.add('active');
      document.querySelectorAll('.gallery-thumbnail').forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
}

// Gift card recipient form toggle
document.querySelectorAll('.recipient-toggle').forEach((checkbox) => {
  const sectionId = checkbox.id.replace('recipient-toggle-', '');
  const fields = document.getElementById('recipient-fields-' + sectionId);
  if (fields) {
    checkbox.addEventListener('change', () => {
      fields.hidden = !checkbox.checked;
    });
  }
});

// Tape scroll tracker
const tapeFill = document.querySelector('.tape-fill');
const tapeTracker = document.getElementById('tape-tracker');

if (tapeFill && tapeTracker) {
  // Update tape fill height based on scroll progress
  function updateTapeFill() {
    const scrollTop = window.scrollY;
    const docHeight = document.body.scrollHeight - window.innerHeight;
    const progress = Math.min(scrollTop / docHeight, 1);
    tapeFill.style.height = (progress * 100) + '%';
  }

  // Build dot markers for each .olc-section
  function buildTapeDots() {
    const sections = document.querySelectorAll('.olc-section');
    if (!sections.length) return;

    const docHeight = document.body.scrollHeight - window.innerHeight;

    sections.forEach((section) => {
      const sectionTop = window.scrollY + section.getBoundingClientRect().top;
      const dot = document.createElement('div');
      dot.classList.add('tape-dot');
      dot.style.top = (sectionTop / docHeight * 100) + '%';
      tapeTracker.appendChild(dot);

      dot._sectionTop = sectionTop;
    });
  }

  function updateDots() {
    const scrollTop = window.scrollY;
    tapeTracker.querySelectorAll('.tape-dot').forEach((dot) => {
      if (scrollTop >= dot._sectionTop) {
        dot.style.height = '7px';
        dot.style.width = '7px';
      } else {
        dot.style.height = '';
        dot.style.width = '';
      }
    });
  }

  window.addEventListener('scroll', updateTapeFill, { passive: true });
  window.addEventListener('scroll', updateDots, { passive: true });
  updateTapeFill();
  buildTapeDots();
  updateDots();
}
